/**
 * Created by haytham.tomeh on 11/28/18.
 */

(function () {

    "use strict";

    angular
        .module('components')
        .component('hMultiLevelSelector', {
            controller: hMultiLevelSelector,
            controllerAs: 'hMultiLevelSelectorComponent',
            bindings: {
                getList: '&',
                onChange: '&',
                initialList : '<',
                name: '@',
                hName: '@',
                hideFilter: '<',
                hideSelectAll: '<',
                disableSelectAll: '<',
                singleSelect : '<',
                returnEmptyArrayOnSelectAll: '<',
                loadAllOnInit: '<',
                loading : '<',
                viewOnly: '<?'
            },
            templateUrl: '../hmodules/components/h-multi-level-selector/h-multi-level-selector.component.ng.html'
        });

    hMultiLevelSelector.$inject = ['$q', '$scope', '$element'];

    function hMultiLevelSelector($q, $scope, $element) {

        var self = this;
        self.name = self.name || self.hName;
        self.CHECKED_VALUE = {
            PARTIAL : 'PARTIAL',
            FULL : 'FULL',
            NONE : 'NONE'
        };


        var ID = function () {
            return 'root_' + Math.random().toString(36).substr(2);
        };
        var rootItemId = ID();

        var allLevels;
        function reset(){

            allLevels = {};
            self.levels = [];

            self.rootItem = {
                hasChilds: true,
                id: rootItemId,
                checked: self.CHECKED_VALUE.NONE,
                selected : false
            };

            self.searchText = {
                label: ''
            };

            self.clickedOptions = {};
            self.selectedItems = [];
        }
        reset();
        self.$onChanges = function (changesObj) {

            if (changesObj.initialList &&
                changesObj.initialList.currentValue !== changesObj.initialList.previousValue){
                reset();
                addNewList(self.initialList,{});
            }

            self.rootItem.disabled = (self.levels && self.levels.length === 0) || (self.levels && self.levels[0] && self.levels[0].length === 0) || self.disableSelectAll;

        }

        var isOptionFullChecked = function(optn){
            return optn.checked == self.CHECKED_VALUE.FULL;
        }

        var getItemCheckedValue = function (item) {
            if(item.selected){
                return  self.CHECKED_VALUE.FULL;
            }
            else {
                return self.CHECKED_VALUE.NONE;
            }
        }

        var getInintialItemCheckedValue = function (item) {

            if(item.selected){
                return self.CHECKED_VALUE.FULL;
            }else{
                if(item.checked){
                    if(item.checked != self.CHECKED_VALUE.FULL &&
                        item.checked != self.CHECKED_VALUE.NONE &&
                        item.checked != self.CHECKED_VALUE.PARTIAL ){
                        return self.CHECKED_VALUE.NONE
                    }else{
                        return item.checked
                    }
                }else{
                    return self.CHECKED_VALUE.NONE;
                }
            }
        }

        var initList = function(list,parent){
            list.forEach(function (item) {
                if(!item.hasOwnProperty('id') || !item.hasOwnProperty('label')){
                    console.error("h-multi-level-selector: every item in the list should have 'id' and 'label' attributes");
                    return;
                }
                item.loading  = false;
                item.level = parent.level? parent.level + 1 : 1;
                item.parent = parent.id || null;
                item.parents = angular.copy(parent.parents) ||  [];
                if(parent.id){
                    item.parents.push(parent.id);
                }


                item.checked = getInintialItemCheckedValue(item);

                if(item.checked == self.CHECKED_VALUE.FULL){
                    item.forceChildsSelectedValue = item.checked;
                }

                if(parent.hasOwnProperty('forceChildsSelectedValue') && !item.disabled){
                    item.checked = parent.forceChildsSelectedValue;
                    item.selected = isOptionFullChecked(item);
                    item.forceChildsSelectedValue = parent.forceChildsSelectedValue;
                    item.selectedByParent = item.selected && self.singleSelect;
                }
            })

            return list;
        }


        var addNewList = function(list,parent, dontOpen){

            var newLevel = initList(list,parent);
            allLevels[parent.id || rootItemId] = newLevel;

            if (!dontOpen) {
                if(self.levels.length >= parent.level){
                    self.levels[parent.level] = newLevel;
                }else{
                    self.levels.push(newLevel);
                }
            }

            if (self.loadAllOnInit) {
                newLevel.forEach(function (optn) {
                    if (optn['hasChilds']) {
                        getList(optn).then(function (list) {
                            addNewList(list,optn, true);
                            optn.loading = false;
                        },function (error) {
                            console.error(error)
                        })
                    }
                });
            }
        }


        function getList(optn){
            var defer = $q.defer();
            if (isSelectedAll()) {
                self.rootItem.selected = true;
                self.rootItem.checked = "FULL";
            }
            if(allLevels[optn.id]){
                defer.resolve( allLevels[optn.id]);
            }else{
                var returnMap = {};
                var promise = self.getList({optn: optn, returnMap: returnMap}) || returnMap['promise'];
                promise.then(function (list) {
                    defer.resolve(list);
                },function (error) {
                    optn.loading = false;
                    console.error(error);
                })
            }
            return defer.promise;
        }

        var getParentCheckedValue = function (parent) {
            let checked = self.CHECKED_VALUE.NONE;
            const childrenCheckedStatuses = allLevels[parent.id].map((child) => child.checked);

            const allChecked = childrenCheckedStatuses.every((checkStatus) => checkStatus === self.CHECKED_VALUE.FULL);

            if (allChecked) {
                checked = self.CHECKED_VALUE.FULL;
            } else if (
                childrenCheckedStatuses.indexOf(self.CHECKED_VALUE.PARTIAL) > -1 ||
                childrenCheckedStatuses.indexOf(self.CHECKED_VALUE.FULL) > -1
            ) {
                checked = self.CHECKED_VALUE.PARTIAL;
            }

            return checked;
        };

        var checkParent = function(optn){

            self.levels.forEach(function (level) {
                var fitem = level[0];
                allLevels[fitem.parent || rootItemId] = level
            });

            if(optn.parent){
                var pid = optn.parent;
                var pindex = optn.level - 2;
                var level = self.levels[pindex];

                var parent = _.find(level, function(item){
                    return item.id == pid;
                });

                if(parent){
                    var checked = getParentCheckedValue(parent);
                    if(parent.checked != checked){
                        delete parent.forceChildsSelectedValue;
                    }
                    parent.checked = checked;
                    parent.selected = isOptionFullChecked(parent);//!!parent.checked;
                    checkParent(parent);
                }

                var i = 0;
                self.levels.forEach(function (level) {
                    var fitem = level[0];
                    self.levels[i] = allLevels[fitem.parent || rootItemId] ;
                    i++;
                });
            }else{

                // first level no parent , also root item no parent
                if(optn.id != rootItemId){
                    self.rootItem.checked = getParentCheckedValue(self.rootItem);
                    self.rootItem.selected = isOptionFullChecked(self.rootItem);//!!parent.checked;
                }
            }

        }

        var checkChilds = function(optn){
            if(optn.hasChilds){

                var oid = optn.id;
                self.levels.forEach(function (level) {
                    var fitem = level[0];
                    allLevels[fitem.parent || rootItemId] = level
                });

                optn.forceChildsSelectedValue = optn.checked;

                var cachedChilds = allLevels[oid];
                if(cachedChilds){
                    cachedChilds.forEach(function (item) {

                        if(!item.disabled){
                            item.checked = optn.checked;
                        }
                        if(item.disabled && optn.checked == self.CHECKED_VALUE.NONE){
                            item.checked = optn.checked;
                        }
                        if(item.disabled && optn.checked == self.CHECKED_VALUE.FULL){
                            item.checked = self.CHECKED_VALUE.NONE;
                        }

                        item.selected = isOptionFullChecked(item);

                        item.selectedByParent = item.selected;

                        if(item.hasChilds){
                            checkChilds(item);
                        }
                    })
                }
                var i = 0;
                self.levels.forEach(function (level) {
                    var fitem = level[0];
                    self.levels[i] = allLevels[fitem.parent || rootItemId] ;
                    i++;
                });

            }
        }

        var isSelectedAll = function () {

            var selectedFromFirstLevel = 0;
            allLevels[rootItemId].forEach(function (_item) {
                if(_item.selected)
                {
                    selectedFromFirstLevel++;
                }
            })

            return selectedFromFirstLevel == allLevels[rootItemId].length;
        }

        var updateSelectedItem = function(level){

            var tmp = {};
            level.forEach(function (_item) {

                var item = angular.copy(_item)
                if(item.checked == self.CHECKED_VALUE.FULL){
                    delete item.forceChildsSelectedValue;
                    delete item.loading;
                    self.selectedItems.push(item);
                }else if(item.hasChilds && item.checked == self.CHECKED_VALUE.PARTIAL && allLevels[item.id]){
                    updateSelectedItem(allLevels[item.id]);
                }

            })
        }


        var handelSelectedItemsChanged = function(){
            self.selectedItems = [];

            if(self.returnEmptyArrayOnSelectAll){
                if(!isSelectedAll()){
                    updateSelectedItem(allLevels[rootItemId]);
                }
            }else{
                updateSelectedItem(allLevels[rootItemId]);
                if (isSelectedAll()) {
                    self.rootItem.selected = true;
                    self.rootItem.checked = "FULL";
                }
            }


            !self.singleSelect && self.onChange && self.onChange({selected : self.selectedItems});
        }

        self.handleOnCheckboxChanged = function (optn) {

            optn.checked = getItemCheckedValue(optn);
            optn.selectedByParent = false;

            checkParent(optn);
            checkChilds(optn);
            handelSelectedItemsChanged();
            $scope.$evalAsync();
        }

        self.onCheckboxTextClicked = function (optn) {

            self.clickedOptions[optn.level] = optn.id;

            if(optn.level < self.levels.length-1){
                self.levels = self.levels.slice(0,optn.level);
            }

            if(!optn.hasChilds){
                if(!optn.disabled){
                    optn.selected = !optn.selected;
                    self.onCheckboxChanged(optn);
                }
                return;
            }

            self.searchText.label = '';
            optn.loading = true;
            getList(optn).then(function (list) {
                addNewList(list,optn);
                optn.loading = false;
                self.levels[optn.optionParentIndex][optn.optionIndex] = optn;
                self.viewTrigger = !self.viewTrigger;
            },function (error) {
                console.error(error)
            })
        }

        self.selectAll = function(){
            self.rootItem.selected = !self.rootItem._selected;
            self.onSelectAllChanged();
        }

        self.onSelectAllChanged = function(){
            self.rootItem._selected = !!self.rootItem.selected;
            self.handleOnCheckboxChanged(self.rootItem);

            var selected = self.rootItem.selected;
            var checked = self.CHECKED_VALUE.NONE;

            if(selected){
                checked = self.CHECKED_VALUE.FULL;
                allLevels[rootItemId].forEach(function(item){
                    if(item.disabled){
                        selected = false;
                        checked = self.CHECKED_VALUE.PARTIAL;
                    }
                });
            }

            self.rootItem.selected = selected;
            self.rootItem.checked = checked;
            self.viewTrigger = !self.viewTrigger;
        }

        self.onCheckboxChanged = function (val) {

            if(val.disabled){
                return;
            }

            var selected = val.selected;
            var selectedByParent = val.selectedByParent;

            if(self.singleSelect){
                self.onChange && self.onChange({selected : val});
                selected = true;
                self.rootItem.selected = false;
                self.onSelectAllChanged();
                val.selected = selected || selectedByParent;
            }else{
                val.selected = selected;
            }


            self.handleOnCheckboxChanged(val);
        };

        var getOriginalScrollValues = function (parentIndex) {
            var scrollTopValues = {};
            var scrollableAreas = $element.find('.scrollable');
            scrollableAreas.each(function (index, element) {
                scrollTopValues[element.id] = element.scrollTop;
            });
            return scrollTopValues;
        };

        var updateScrollableTopValues = function (scrollTopValues) {
            var scrollableAreas = $element.find('.scrollable');

            scrollableAreas.each(function (index, element) {
                element.scrollTop = scrollTopValues[element.id] || 0;
            });
        };

        self.assignHandlers = function (element) {

            element.find(".multi-level-selector-checkbox-label").on("click", function () {
                var clickedElm = $(this);
                var optionIndex = clickedElm.data("index");
                var optionParentIndex = clickedElm.data("parent-index");
                var option = self.levels[optionParentIndex][optionIndex];
                var originalScrollValues = getOriginalScrollValues();
                option.optionIndex = optionIndex;
                option.optionParentIndex = optionParentIndex;
                self.onCheckboxTextClicked(option);
                self.levels = angular.copy(self.levels);
                self.viewTrigger = !self.viewTrigger;
                $scope.$digest();
                updateScrollableTopValues(originalScrollValues);
            });

            element.find(".multi-level-selector-checkbox-icon input[type='checkbox']").on("change", function () {
                var clickedElm = $(this);
                var optionIndex = clickedElm.data("index");
                var optionParentIndex = clickedElm.data("parent-index");
                var option = self.levels[optionParentIndex][optionIndex];
                var originalScrollValues = getOriginalScrollValues();

                if (clickedElm.is(':checked')) {
                    option.checked = self.CHECKED_VALUE.FULL;
                    option.selected = true;
                } else {
                    option.checked = self.CHECKED_VALUE.NONE;
                    option.selected = false;
                }

                self.onCheckboxChanged(option);
                self.levels = angular.copy(self.levels);
                self.viewTrigger = !self.viewTrigger;
                $scope.$digest();
                updateScrollableTopValues(originalScrollValues);
            });

        };

    }
})();
